"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InnerContainer = styled_components_1.default.div `
  padding-left: 0px;
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 0px;
`;
//# sourceMappingURL=inner-container.js.map